import React from 'react'
import { MDBContainer, MDBRow, MDBCol } from 'mdbreact'
import CountUp from 'react-countup'
import { HashLink as Link } from 'react-router-hash-link';

const Counter = ({count}) => {
    return (
        <>
        <MDBContainer className="mt-5 mb-5">
            <MDBRow>
                <MDBCol>
                    <div style={{ border: '4px solid white', padding: '5%' }}>
                        <div className="counter-container">
                            <div className="d-flex white-text justify-content-center align-content-center align-items-center p-1">      
                                <CountUp 
                                    style={{ letterSpacing: '0.5rem' }} 
                                    className="h1-responsive align-self-center font-weight-bold mb-3" 
                                    duration={20} start={0} end={count} /> 
                                <h2 style={{ letterSpacing: '0.5rem' }} className="h2-responsive text-uppercase font-weight-bold ml-3">
                                native trees adopted
                                </h2>
                            </div>
                        </div>
                        <div className="counter-container-mobile">
                            <div className="d-flex flex-column white-text justify-content-center align-content-center align-items-center p-1">      
                                <CountUp 
                                    style={{ letterSpacing: '0.5rem', fontSize: '40px' }} 
                                    className="p-2 align-self-center font-weight-bold" 
                                    duration={20} start={0} end={501} /> 
                                <h2 style={{ letterSpacing: '0.5rem' }} className="h2-responsive text-center mb-4 text-uppercase font-weight-bold ml-3">
                                native trees adopted
                                </h2>
                            </div>
                        </div>
                        <div className="counter-container">
                            <div style={{ marginBottom: '-4%' }}  className="d-flex justify-content-end">
                                <Link smooth to="/blog/5f423441cf74b00df8000539#blog" className="counter-link white-text font-weight-bold text-uppercase">
                                    find out more here
                                </Link>
                            </div>
                        </div>
                        <div className="counter-container-mobile">
                            <div style={{ marginBottom: '-4%' }}  className="d-flex justify-content-center">
                                <Link smooth to="/blog/5f423441cf74b00df8000539#blog" style={{ fontSize: '20px' }} className="counter-link white-text text-center font-weight-bold text-uppercase">
                                    find out more here
                                </Link>
                            </div>
                        </div>
                    </div>
                </MDBCol>
            </MDBRow>
        </MDBContainer> 
        </>
    )
}

export default Counter
